import i18n from '../../../i18n';

const getTyreDetailsApi = async (ean, language = null) => {
  const lang = language || i18n.language || 'en';
  const query = `
    query GetTyreDetails {
      getProductLineListing(
        filter: "{\\"query\\": {\\"ean\\": \\"${ean}\\"}}"
        first: 1
        defaultLanguage: "${lang}"
      ) {
        edges {
          node {
            artNo11Digit
            ean
            singleBrandKey {
              ... on object_Brand {
                name
              }
            }
            productName
            marketingText
            mainImage {
              fullpath
            }
            frontView {
              fullpath
            }
            cutNoRim {
              fullpath
            }
            noRim {
              fullpath
            }
            pogProductGroup {
              ... on object_ProductGroup {
                name
              }
            }
            productLineMarketingLine
            exportName_approved
            introText_approved
            sub_headline_approved
            subline_approved
            headline_approved
            bulletpointsIntern1_approved
            bulletpointsIntern2_approved
            bulletpointsIntern3_approved
            bulletpointsIntern4_approved
            bulletpointsIntern5_approved
            bulletpointsIntern6_approved
            bulletpointsExtern1_approved
            bulletpointsExtern2_approved
            bulletpointsExtern3_approved
            bulletpointsExtern4_approved
            bulletpointsExtern5_approved
            bulletpointsExtern6_approved
            techHighlightsDescriptionsB2C1_approved
            techHighlightsDescriptionsB2C2_approved
            techHighlightsDescriptionsB2C3_approved
            techHighlightsDescriptionsB2C4_approved
            techHighlightsDescriptionsB2C5_approved
            techHighlightsDescriptionsB2C6_approved
            techHighlightsDescriptionsB2B1_approved
            techHighlightsDescriptionsB2B2_approved
            techHighlightsDescriptionsB2B3_approved
            techHighlightsDescriptionsB2B4_approved
            techHighlightsDescriptionsB2B5_approved
            techHighlightsDescriptionsB2B6_approved
            oeKeyKey
            oeManufacture
            snowflakeSymbol
            additionalProperties
            additionalPropertiesKey
            additionalProperties2
            aspectRatio
            axlePosition
            axlePositionKey
            dimensionMetric
            flangeRib
            ltFlag
            load1
            loadCapacity
            loadCapacityKey
            loadIndex2
            loadRange
            loadRangeKey
            loadSpeedIndex
            mbrandText
            mSMark
            mbIdentificationRib
            marketingLineKey
            maxLoad
            maxLoadAtMaxSpeed
            maxSpeed
            oeIndicator
            oeKey
            oeManufactureKey
            productNameKey
            rimDiameterInch
            rimDiameterMm
            rimWidth
            season
            seasonKey
            sidewallDesign
            sidewallDesignKey
            silent
            zz_elec_veh
            E2_3PMSF
            EPREL_REG_E2
            EOP_WEEK_E2
            EOP_YEAR_E2
            ROLL_NOISE_E2
            ROLL_NOISE
            FUEL_EFFI_E2
            FUEL_EFFI
            NOISE_UNIT_E2
            NOISE_UNIT
            ICE_PICT_E2
            NOISE_LEV_E2
            NOISE_LEV
            REG_REF_E2
            REG_REF
            TIRE_CLASS_E2
            TIRE_CLASS
            WET_GRIP_E2
            WET_GRIP
            microsite_b2b_link
            microsite_eulabel_link
            microsite_productline_link
            testResults {
              element {
                ... on asset {
                  fullpath
                }
              }
            }
            additionalVisuals {
              element {
                ... on asset {
                  fullpath
                }
              }
            }
            euLabelPerformanceAsset {
              element {
                ... on asset {
                  fullpath
                }
              }
            }
            keyVisuals {
              element {
                ... on asset {
                  fullpath
                }
              }
            }
            oeApprovals {
              element {
                ... on asset {
                  fullpath
                }
              }
            }
            pressTest {
              element {
                ... on asset {
                  fullpath
                }
              }
            }
            technicalHighlights {
              element {
                ... on asset {
                  fullpath
                }
              }
            }
            spiderPerformance {
              element {
                ... on asset {
                  fullpath
                }
              }
            }
            vehicleFitments {
              element {
                ... on asset {
                  fullpath
                }
              }
            }
            productVideo {
              element {
                ... on asset {
                  fullpath
                }
              }
            }
            productImagesOthers {
              ... on hotspotimage {
                image {
                  fullpath
                }
              }
            }
            application {
              ... on object_Application {
                name
              }
            }
            productionOrigin {
              ... on object_ProductionOrigin {
                name
              }
            }
            vehicleType {
              ... on object_VehicleType {
                name
              }
            }
            approvedRims
            maxLoadAtInflationDualKg
            maxLoadAtInflationSingleLbs
            speed {
              ... on object_Speed {
                name
              }
            }
            sustainability {
              ... on object_Sustainability {
                name
              }
            }
          }
        }
      }
    }
  `;

  try {
    const response = await fetch('/api/graphql-proxy', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({query}),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const result = await response.json();

    if (result.errors) {
      console.error('GraphQL errors:', result.errors);
      throw new Error(result.errors[0].message);
    }

    return result.data;
  } catch (error) {
    console.error('API call failed:', error.message);
    throw error;
  }
};

export default getTyreDetailsApi;
